import { MbAddToCartService } from '../../../shared/services/mb-add-to-cart.service'
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { CurrentProductService } from '@spartacus/storefront'
import { EventService, isNotNullable, Product } from '@spartacus/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { filter } from 'rxjs/operators'
import { SearchUtilsService } from '../../../search/services/search-utils.service'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { MbModalService } from '../../../shared/services/modal.service'
import { Subscription } from 'rxjs'
import { DataAnalyticsClickSource } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-add-to-cart',
  templateUrl: './mb-add-to-cart.component.html',
  styleUrls: ['./mb-add-to-cart.component.scss'],
})
export class MbAddToCartComponent implements OnInit, OnDestroy {

  @Input()
  hasPriceOnRequest = false
  @Input()
  showQuantity = false

  @Input()
  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  })

  @Input()
  product: Product | undefined

  @Input()
  productCode: string | undefined

  @Input()
  clickSource: DataAnalyticsClickSource | undefined

  facetsExpanded$ = this.searchFilterService.isFacetsExpanded$
  maxQuantity: number | undefined
  quantity = 1
  hasStock = false
  inventoryThreshold = false
  subscription = new Subscription()

  constructor (protected currentProductService: CurrentProductService,
               protected cd: ChangeDetectorRef,
               protected activeCartService: ActiveCartFacade,
               protected eventService: EventService,
               protected searchFilterService: SearchUtilsService,
               protected modalService: MbModalService,
               protected addToCartService: MbAddToCartService) { }

  ngOnInit () {
    if (this.product) {
      this.productCode = this.product.code ?? ''
      this.setStockInfo(this.product)
      this.cd.markForCheck()
    } else if (this.productCode) {
      // force hasStock and quantity for the time being, as we do not have more info:
      this.quantity = 1
      this.hasStock = true
      this.cd.markForCheck()
    } else {
      this.subscription = (this.currentProductService.getProduct()).pipe(
        filter(isNotNullable)
      ).subscribe((product) => {
          this.productCode = product.code ?? ''
          this.setStockInfo(product)
          this.cd.markForCheck()
        })
    }
  }

  ngOnDestroy () {
    this.subscription?.unsubscribe()
  }

  protected setStockInfo (product: Product) {
    this.quantity = 1
    this.hasStock = Boolean(product.stock?.stockLevelStatus !== 'outOfStock')

    this.inventoryThreshold = product.stock?.isValueRounded ?? false

    if (this.hasStock && product.stock?.stockLevel) {
      this.maxQuantity = product.stock.stockLevel
    }
  }

  addToCart () {
    const quantity = this.addToCartForm?.get('quantity')?.value
    if (!this.productCode || quantity <= 0) {
      return
    } else {
      this.addToCartService.addToCart({
        productCode: this.productCode,
        quantity: quantity,
        source: this.clickSource
      })
    }
  }
}
